import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useCartStore } from '../context/store';
import api from '../utils/api';
import toast from 'react-hot-toast';

const C = { prune:'#4A1942',pruneL:'#6B2E62',pruneD:'#2D0F28',or:'#C9A84C',creme:'#FDF6EC',cremeD:'#F5E8D3',cremeMid:'#EDD9BB',noir:'#1A0F18',gris:'#5C4A58',grisM:'#8B7A86',grisL:'#C4B8C0',vert:'#27AE60',rouge:'#C0392B' };

export default function Product() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addItem } = useCartStore();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTaille, setSelectedTaille] = useState('');
  const [selectedCouleur, setSelectedCouleur] = useState('');
  const [qty, setQty] = useState(1);
  const [imgIdx, setImgIdx] = useState(0);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    setLoading(true);
    api.get('/products/' + id)
      .then(r => {
        const p = r.data.product;
        setProduct(p);
        if (p.tailles?.length) setSelectedTaille(p.tailles[0]);
        if (p.couleurs?.length) setSelectedCouleur(p.couleurs[0].nom);
        return api.get('/products?categorie=' + p.categorie + '&limit=4');
      })
      .then(r => setRelated((r.data.products || []).filter(p => p.id !== parseInt(id)).slice(0, 3)))
      .catch(() => toast.error('Produit non trouvé'))
      .finally(() => setLoading(false));
  }, [id]);

  const handleAddToCart = () => {
    if (!selectedTaille) return toast.error('Choisissez une taille');
    if (product.stock === 0) return toast.error('Produit épuisé');
    addItem(product, selectedTaille, selectedCouleur, qty);
    toast.success('Ajouté au panier !');
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: C.creme, paddingTop: 72, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 40, height: 40, border: `2px solid ${C.cremeD}`, borderTopColor: C.prune, borderRadius: '50%', animation: 'spin .8s linear infinite' }} />
    </div>
  );

  if (!product) return null;

  const prix = product.prix_promo || product.prix;
  const hasPromo = !!product.prix_promo;
  const remise = hasPromo ? Math.round((1 - product.prix_promo / product.prix) * 100) : 0;
  const images = product.images?.length ? product.images : [null];

  return (
    <div style={{ minHeight: '100vh', background: C.creme, paddingTop: 72 }}>
      {/* Breadcrumb */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '16px 24px', display: 'flex', gap: 8, alignItems: 'center', fontSize: 12, color: C.grisM, fontFamily: 'monospace' }}>
        <Link to="/" style={{ color: C.grisM, textDecoration: 'none' }}>Accueil</Link>
        <span>›</span>
        <Link to="/boutique" style={{ color: C.grisM, textDecoration: 'none' }}>Boutique</Link>
        <span>›</span>
        <Link to={`/boutique?categorie=${product.categorie}`} style={{ color: C.grisM, textDecoration: 'none', textTransform: 'capitalize' }}>{product.categorie}</Link>
        <span>›</span>
        <span style={{ color: C.pruneD }}>{product.nom}</span>
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px 64px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'start' }}>

          {/* Galerie photos */}
          <div>
            <div style={{ position: 'relative', borderRadius: 20, overflow: 'hidden', background: `linear-gradient(135deg, ${C.cremeD}, ${C.cremeMid})`, aspectRatio: '3/4', marginBottom: 12 }}>
              {images[imgIdx] ? (
                <img src={images[imgIdx]} alt={product.nom} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 96, opacity: .4 }}>🌺</div>
              )}
              {hasPromo && <span style={{ position: 'absolute', top: 16, left: 16, background: C.rouge, color: 'white', fontSize: 13, fontWeight: 700, padding: '5px 12px', borderRadius: 20, fontFamily: 'monospace' }}>-{remise}%</span>}
            </div>
            {images.length > 1 && (
              <div style={{ display: 'flex', gap: 8 }}>
                {images.map((img, i) => (
                  <div key={i} onClick={() => setImgIdx(i)} style={{ width: 72, height: 90, borderRadius: 8, overflow: 'hidden', cursor: 'pointer', border: `2px solid ${imgIdx === i ? C.prune : C.cremeD}`, transition: 'border-color .2s', flexShrink: 0 }}>
                    {img ? <img src={img} alt={i} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '100%', background: C.cremeD, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🌺</div>}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Infos produit */}
          <div style={{ position: 'sticky', top: 88 }}>
            <span style={{ fontSize: 11, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.15em', color: C.prune, fontWeight: 600 }}>{product.categorie}</span>
            <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 36, color: C.pruneD, margin: '8px 0 16px', lineHeight: 1.2 }}>{product.nom}</h1>

            {/* Prix */}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 24 }}>
              <span style={{ fontFamily: 'monospace', fontSize: 28, fontWeight: 700, color: C.prune }}>{prix.toLocaleString('fr-CI')} FCFA</span>
              {hasPromo && <span style={{ fontFamily: 'monospace', fontSize: 18, color: C.grisL, textDecoration: 'line-through' }}>{product.prix.toLocaleString('fr-CI')}</span>}
            </div>

            {/* Stock */}
            <div style={{ marginBottom: 24 }}>
              {product.stock === 0 ? (
                <span style={{ background: '#FDEDEC', color: C.rouge, fontSize: 12, fontWeight: 600, padding: '4px 12px', borderRadius: 20, fontFamily: 'monospace' }}>❌ Épuisé</span>
              ) : product.stock < 10 ? (
                <span style={{ background: '#FEF3E2', color: '#E67E22', fontSize: 12, fontWeight: 600, padding: '4px 12px', borderRadius: 20, fontFamily: 'monospace' }}>⚠ Plus que {product.stock} disponible{product.stock > 1 ? 's' : ''}</span>
              ) : (
                <span style={{ background: '#EAFAF1', color: C.vert, fontSize: 12, fontWeight: 600, padding: '4px 12px', borderRadius: 20, fontFamily: 'monospace' }}>✓ En stock ({product.stock})</span>
              )}
            </div>

            {/* Tailles */}
            {product.tailles?.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <p style={{ fontSize: 12, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.08em', color: C.grisM, marginBottom: 10 }}>Taille</p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {product.tailles.map(t => (
                    <button key={t} onClick={() => setSelectedTaille(t)}
                      style={{ padding: '8px 18px', borderRadius: 8, border: `1.5px solid ${selectedTaille === t ? C.prune : C.cremeD}`, background: selectedTaille === t ? `linear-gradient(135deg, ${C.prune}, ${C.pruneL})` : 'white', color: selectedTaille === t ? C.or : C.gris, fontFamily: 'monospace', fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all .15s' }}>
                      {t}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Couleurs */}
            {product.couleurs?.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <p style={{ fontSize: 12, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.08em', color: C.grisM, marginBottom: 10 }}>Couleur — <span style={{ color: C.pruneD, fontWeight: 600 }}>{selectedCouleur}</span></p>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {product.couleurs.map(c => (
                    <button key={c.nom} onClick={() => setSelectedCouleur(c.nom)} title={c.nom}
                      style={{ width: 36, height: 36, borderRadius: '50%', background: c.hex, border: `3px solid ${selectedCouleur === c.nom ? C.prune : 'white'}`, outline: `2px solid ${selectedCouleur === c.nom ? C.prune : C.cremeD}`, cursor: 'pointer', transition: 'all .15s', flexShrink: 0 }} />
                  ))}
                </div>
              </div>
            )}

            {/* Quantité */}
            <div style={{ marginBottom: 28 }}>
              <p style={{ fontSize: 12, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.08em', color: C.grisM, marginBottom: 10 }}>Quantité</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 0, border: `1.5px solid ${C.cremeD}`, borderRadius: 10, overflow: 'hidden', width: 'fit-content' }}>
                <button onClick={() => setQty(q => Math.max(1, q - 1))} style={{ width: 44, height: 44, border: 'none', background: C.cremeD, cursor: 'pointer', fontSize: 20, color: C.gris }}>−</button>
                <span style={{ width: 52, textAlign: 'center', fontSize: 16, fontWeight: 700, color: C.pruneD, fontFamily: 'monospace' }}>{qty}</span>
                <button onClick={() => setQty(q => Math.min(product.stock, q + 1))} style={{ width: 44, height: 44, border: 'none', background: C.cremeD, cursor: 'pointer', fontSize: 20, color: C.gris }}>+</button>
              </div>
            </div>

            {/* CTA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <button onClick={handleAddToCart} disabled={product.stock === 0}
                style={{ padding: '16px', background: product.stock === 0 ? C.grisL : `linear-gradient(135deg, ${C.prune}, ${C.pruneL})`, color: product.stock === 0 ? 'white' : C.or, border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: product.stock === 0 ? 'not-allowed' : 'pointer', fontFamily: 'DM Sans, sans-serif', boxShadow: product.stock === 0 ? 'none' : `0 4px 20px rgba(74,25,66,.3)`, transition: 'all .2s' }}>
                🛍 {product.stock === 0 ? 'Produit épuisé' : 'Ajouter au panier'}
              </button>
              <a href={`https://wa.me/225XXXXXXXX?text=${encodeURIComponent(`Bonjour ! Je suis intéressé(e) par : ${product.nom} (${prix.toLocaleString('fr-CI')} FCFA). Taille: ${selectedTaille}`)}`}
                target="_blank" rel="noreferrer"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '14px', background: '#25D366', color: 'white', borderRadius: 12, fontSize: 15, fontWeight: 600, textDecoration: 'none' }}>
                💬 Commander via WhatsApp
              </a>
            </div>

            {/* Description */}
            {product.description && (
              <div style={{ marginTop: 32, paddingTop: 28, borderTop: `1px solid ${C.cremeD}` }}>
                <h3 style={{ fontFamily: 'Georgia, serif', fontWeight: 400, fontSize: 18, color: C.pruneD, marginBottom: 12 }}>Description</h3>
                <p style={{ fontSize: 14, color: C.gris, lineHeight: 1.8 }}>{product.description}</p>
              </div>
            )}

            {/* Livraison */}
            <div style={{ marginTop: 24, padding: 16, background: `linear-gradient(135deg, ${C.cremeD}, ${C.creme})`, borderRadius: 12, border: `1px solid ${C.cremeMid}` }}>
              {[
                { icon: '🏠', label: 'Domicile Abidjan', detail: '24-48h · 2 000 FCFA' },
                { icon: '🏪', label: 'Click & Collect', detail: 'Même jour · Gratuit' },
                { icon: '🚚', label: 'National CI', detail: '3-5 jours · 5 000 FCFA' },
              ].map(l => (
                <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8, fontSize: 13 }}>
                  <span>{l.icon}</span>
                  <span style={{ fontWeight: 500, color: C.pruneD }}>{l.label}</span>
                  <span style={{ color: C.grisM, marginLeft: 'auto', fontFamily: 'monospace', fontSize: 11 }}>{l.detail}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Produits similaires */}
        {related.length > 0 && (
          <div style={{ marginTop: 64 }}>
            <h2 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 28, color: C.pruneD, marginBottom: 24 }}>Articles similaires</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20 }}>
              {related.map(p => {
                const pxr = p.prix_promo || p.prix;
                const img = p.images?.[0];
                return (
                  <div key={p.id} onClick={() => navigate(`/produit/${p.id}`)} style={{ background: 'white', borderRadius: 16, overflow: 'hidden', cursor: 'pointer', border: `1px solid ${C.cremeMid}`, transition: 'all .25s' }}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 8px 32px rgba(74,25,66,.12)`; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                    <div style={{ aspectRatio: '3/4', background: `linear-gradient(135deg, ${C.cremeD}, ${C.cremeMid})`, overflow: 'hidden' }}>
                      {img ? <img src={img} alt={p.nom} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 48 }}>🌺</div>}
                    </div>
                    <div style={{ padding: '12px 14px' }}>
                      <p style={{ fontFamily: 'Georgia, serif', fontSize: 15, color: C.pruneD, marginBottom: 6, lineHeight: 1.3 }}>{p.nom}</p>
                      <p style={{ fontFamily: 'monospace', fontSize: 14, fontWeight: 700, color: C.prune }}>{pxr.toLocaleString('fr-CI')} FCFA</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
